var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-dialog" }, [
    _c("div", { staticClass: "modal_content" }, [
      _c("div", { staticClass: "modal_header" }, [
        _c("h5", [_vm._v(" Resource Types ")]),
        _vm._v(" "),
        _c("button", {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          },
          on: {
            click: function($event) {
              return _vm.close()
            }
          }
        })
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "modal_footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("sdl.common.label.close")))]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal_body" }, [
      _c("div", { staticClass: "form_wrap" }, [
        _c("table", { staticClass: "form_table" }, [
          _c("colgroup", [
            _c("col", { attrs: { width: "250px" } }),
            _vm._v(" "),
            _c("col")
          ]),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c(
                "th",
                {
                  staticStyle: { "font-weight": "500", "text-align": "center" }
                },
                [_vm._v("Resource")]
              ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticStyle: { "font-weight": "500", "text-align": "center" }
                },
                [_vm._v("Types")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("td", { staticStyle: { "font-weight": "400" } }, [
                _vm._v("EC2")
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticStyle: { "font-weight": "400", "line-height": "2" } },
                [
                  _vm._v("\n                .AWS : EC2"),
                  _c("br"),
                  _vm._v(
                    "\n                .Azure : Virtual machines, SQL Virtual Machines"
                  ),
                  _c("br"),
                  _vm._v("\n                .GCP : Compute Engine"),
                  _c("br"),
                  _vm._v("\n                .Ali : ECS"),
                  _c("br"),
                  _vm._v("\n                .NCP : Server"),
                  _c("br"),
                  _vm._v("\n                .OCI : Instance"),
                  _c("br"),
                  _vm._v("\n                .SCP : Server\n              ")
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticStyle: { "font-weight": "400" } }, [
                _vm._v("RDS")
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticStyle: { "font-weight": "400", "line-height": "2" } },
                [
                  _vm._v(
                    "\n                .AWS : RDS(Amazon Aurora, MariaDB, MySQL, Oracle, PostgreSQL, SQL Server)"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n                .Azure : SQL Managed Instances, MySQL Flexible Servers, PostgreSQL Flexible Servers, Synapse Analytics, SQL Servers(SQL Database)"
                  ),
                  _c("br"),
                  _vm._v("\n                .Ali : AsparaDB(MSSQL, MYSQL)"),
                  _c("br"),
                  _vm._v("\n                .NCP : MySQL"),
                  _c("br"),
                  _vm._v(
                    "\n                .OCI : MySQL, Oracle Base Database Service"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n                .SCP : MariaDB, MySQL, PoatgreSQL, SQL Server\n              "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticStyle: { "font-weight": "400" } }, [
                _vm._v("S3/DynamoDB/Storage Account")
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticStyle: { "font-weight": "400", "line-height": "2" } },
                [
                  _vm._v("\n                .AWS : S3, DynomoDB"),
                  _c("br"),
                  _vm._v(
                    "\n                .Azure : Storage Account\n              "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticStyle: { "font-weight": "400" } }, [
                _vm._v("GCP Service")
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticStyle: { "font-weight": "400", "line-height": "2" } },
                [
                  _vm._v(
                    "\n                .GCP : Cloud Function, Cloud Bigtable, Datastore, BigQuery, Filestore, Cloud Storage\n              "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticStyle: { "font-weight": "400" } }, [
                _vm._v("Etc.")
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticStyle: { "font-weight": "400", "line-height": "2" } },
                [
                  _vm._v("\n                .AWS : Neptune, EFS"),
                  _c("br"),
                  _vm._v(
                    "\n                .Azure : Azure Cache for Redis, Azure Cosmos DB for NoSQL, Azure Cosmos DB for MongoDB (RU), Azure Cosmos DB for MongoDB (vCore Cluster),"
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "padding-left": "50px" } }, [
                    _vm._v(
                      "Azure Cosmos DB for Table, Azure Cosmos DB for Gremlin, Azure Cosmos DB for Apache Cassandra (RU)"
                    )
                  ]),
                  _c("br"),
                  _vm._v(
                    "\n                .GCP : Cloud SQL(MySQL)\n              "
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b6fb4836", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6fb4836","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/rem/permissionManager/resource/popup/ResourceTypesPopup.vue
// module id = null
// module chunks = 